import React, { useState } from 'react'
import { ArrowLeft } from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'
import { useSidebarCollapse } from '../../../../../contexts/SidebarCollapseContext'

export default function BackButton() {
  const navigate = useNavigate()
  const { isCollapsed } = useSidebarCollapse()
  const [showTooltip, setShowTooltip] = useState(false)

  const navigateBackToCampaigns = () => navigate('/project_manager/campaigns')

  return (
    <div className="relative">
      <button
        className={`flex mb-4 items-center ${isCollapsed ? 'justify-center px-2' : 'px-4'} w-full hover:bg-gray-300 dark:hover:bg-rb-dark-mode-lighter py-2 dark:text-white`}
        onClick={navigateBackToCampaigns}
        onMouseEnter={() => isCollapsed && setShowTooltip(true)}
        onMouseLeave={() => setShowTooltip(false)}
        title={isCollapsed ? 'Back to campaigns' : undefined}
      >
        <ArrowLeft />
        {!isCollapsed && <p className="pl-4 dark:text-white">Back to campaigns</p>}
      </button>
      {isCollapsed && showTooltip && (
        <div className="absolute left-full ml-2 px-3 py-2 bg-gray-900 dark:bg-gray-700 text-white text-sm rounded-md whitespace-nowrap z-50 shadow-lg pointer-events-none">
          Back to campaigns
          <div className="absolute right-full top-1/2 -translate-y-1/2 border-4 border-transparent border-r-gray-900 dark:border-r-gray-700"></div>
        </div>
      )}
    </div>
  )
}